module.exports = __webpack_public_path__ + "img/bg_court_04.27bd39ff.jpg";